var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashTransitIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00133 9.49633C3.98199 9.84186 4.17535 10.1638 4.48977 10.3084L10.7984 13.2021L13.692 19.5099C13.8299 19.8092 14.1292 20 14.4562 20L14.5042 19.9983C14.6729 19.9889 14.8348 19.9288 14.9689 19.8259C15.103 19.723 15.2029 19.5821 15.2557 19.4216L19.9594 5.10285C20.0578 4.80188 19.9788 4.4698 19.7552 4.24533C19.5315 4.02087 19.2003 3.94436 18.8976 4.04104L4.57805 8.74475C4.41751 8.79754 4.27662 8.8975 4.17374 9.03157C4.07086 9.16564 4.01078 9.3276 4.00133 9.49633ZM17.8426 6.15792L14.3268 16.86L12.1964 12.2177C12.1127 12.0346 11.9658 11.8878 11.7828 11.804L7.13881 9.67372L17.8426 6.15792Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashTransitIcon);
export default __webpack_public_path__ + "static/media/dash-transit-icon.558e8062.svg";
export { ForwardRef as ReactComponent };